import { observable } from "mobx";
import {
  TravelRequest_getBookingGroup,
  TravelRequestBookingGroupDataFragment
} from "@graphql";
import { store } from "@store";
import locale from "@bonliva-crm/locale";
import { Option } from "@components/formx/Select";
import { orderBy } from "lodash";

export class TravelRequestFormStore {
  @observable loading = true;
  bookingData: TravelRequestBookingGroupDataFragment;

  constructor(public bookingGroupId?: string) {
    this.init();
  }

  init() {
    if (!this.bookingGroupId) {
      this.loading = false;

      return;
    }

    TravelRequest_getBookingGroup.func(
      { id: this.bookingGroupId },
      { fetchPolicy: "network-only" }
    )
      .then(({ data }) => {
        this.bookingData = data.getBookingGroup;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get allCountriesOptions(): Option[] {
    return orderBy(store().cache.allCountriesWorldwide, (x) => x.canWorkIn, "asc").map(
      (c) => ({
        label: locale.countries[c.name],
        value: c.name
      })
    );
  }
}
